import DOMPurify from "dompurify";

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    "b", "i", "em", "strong", "u", "s", "p", "br", "ul", "ol", "li",
    "span", "a", "blockquote", "code", "pre",
  ],
  ALLOWED_ATTR: [
    "href", "target", "rel", "class", "style",
    "data-type", "data-id", "data-user-id", "data-user-email", "data-user-label",
  ],
};

export const sanitizeHtml = (dirtyHtml) => {
  if (!dirtyHtml) return "";
  return DOMPurify.sanitize(String(dirtyHtml), SANITIZE_CONFIG);
};
